import styled from 'styled-components';
import { StylesConfig } from 'react-select';

import { DefaultTheme } from 'styled-components';

export function selectStyles(theme: DefaultTheme): StylesConfig<any, any> {
  const { colors } = theme;

  return {
    option: (provided, state) => {
      let backgroundColor = '';

      if (state.isSelected) backgroundColor = colors.secondary;
      else if (state.isFocused) backgroundColor = colors.secondaryBright;

      return {
        ...provided,
        color: colors.text,
        backgroundColor,
        padding: 10,
        transition: 'all 200ms ease-in-out',
        fontSize: '12px',
        textAlign: 'left',

        '&:hover': {
          backgroundColor: colors.secondaryBright,
        },
      };
    },
    container: (provided) => ({
      ...provided,
      width: '180px',
      padding: '0px',
      textAlign: 'center',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '12px',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '12px',
      textAlign: 'center',
    }),
    menu: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    input: (provided) => ({
      ...provided,
      textAlign: 'center',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: '0px',
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'nowrap',
      ':-webkit-flex-wrap': 'nowrap',
    }),
    control: (provided: any, state) => {
      const { selectProps } = state;
      const { menuIsOpen } = selectProps;

      return {
        ...provided,
        boxShadow: 'none',
        border: `2px solid ${menuIsOpen ? colors.secondary : colors.grey}`,
        borderRadius: '0',
        transition: 'all 200ms ease-in-out',

        '&:hover': {
          borderColor: colors.secondary,
        },
        '&:focus': {
          borderColor: colors.secondary,
        },
        '&:active': {
          borderColor: colors.secondary,
        },
      };
    },
  };
}

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .label {
    font-size: 14px;
    margin-bottom: 5px;
  }
`;
